var jQuery = require('jquery');
window.jQuery = jQuery;
window.$ = jQuery;

var moment = require('moment');
window.moment = moment;

require('moment');
require('bootstrap-v3/js/transition');
require('bootstrap-v3/js/alert');
require('bootstrap-v3/js/dropdown');
require('bootstrap-v3/js/collapse');
require('bootstrap-v3/js/tab');
require('bootstrap-v3/js/modal');
require('bootstrap-v3/js/tooltip');
require('bootstrap-v3/js/popover');
require('bootstrap-select');
require('bootstrap-datepicker');
require('bootstrap-datetimepicker-npm')($);

require('jquery.placeholder');
require('jquery-sticky');
require('jquery-match-height');

require('owl.carousel');
require('magnific-popup');
require('lazysizes');
require('picturefill');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function () {

    // Initialise the Ajax funxctions - put most of your js calls in this function
    // or if you need to reload them after an ajax call
    initAjaxJS();

    // $(window).load(function() {
    // });

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }


    $(".sticky-nav-mob").sticky({ topSpacing: 0 });
    $(".sticky-nav").sticky({ topSpacing: 0 });
    $(".sticky-nav2").sticky({ topSpacing: 0 });
    // $(".sticky-head-logo").sticky({ topSpacing: 0 });

    // jQuery to collapse the navbar on scroll
    $(window).scroll(function() {
        var offset = $(".sticky-nav").offset();
        if (offset && offset.top > 108) {
            $(".navbar-logo .sml-logo").addClass("fade-logo");
        } else {
            $(".navbar-logo .sml-logo").removeClass("fade-logo");
        }
    });

    $(window).scroll(function() {
        var offset = $(".sticky-nav2").offset();
        if (offset && offset.top > 108) {
            $(".navbar-logo .sml-logo").addClass("fade-logo");
        } else {
            $(".navbar-logo .sml-logo").removeClass("fade-logo");
        }
    });

    // jQuery to collapse the navbar on scroll
    $(window).scroll(function() {
        var offset = $(".sticky-nav__wrap").offset();
        if (offset && offset.top > 130) {
            $(".navbar-logo-sticky").addClass("fadein");
        } else {
            $(".navbar-logo-sticky").removeClass("fadein");
        }
    });



    // placeholder polyfill for browsers that need it
    $('input, textarea').placeholder();

    $('.selectpicker').selectpicker({
        style: 'btn-default',
        // size: 8
    });

    // Off canvas mobile nav
    $('[data-toggle="offcanvas"]').click(function() {
        $('.offcanvas').toggleClass('active');
        $(this).toggleClass('close-btn')

    });

    
    $("#share-btn").on('click', function() {
        $(".share-icons").toggleClass("open");
    });

    $('.homepage-slider').each(function(idx, panel) {
        $(panel).owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: false,
            items: 1,
            autoplay: true,
            autoplayTimeout: 6000,
            smartSpeed: 750,
            autoHeight: false,
            nav: false,
            dots: true,
            responsive: {
                992: {
                    nav: true,
                    dots: false
                }
            }
        })

    var owl;
    owl = $(".owl-carousel").owlCarousel({
        nav: true,
        autoplay: true,
        autoplayTimeout: 2000
    });

    owl.on('changed.owl.carousel', function(e) {
        owl.trigger('stop.owl.autoplay');
        owl.trigger('play.owl.autoplay');
    });

    });

    

    



    if ($('.carousel-5-column').length) {
        $('.carousel-5-column').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: false,
            items: 1,
            autoplay: true,
            autoplayTimeout: 6000,
            smartSpeed: 750,
            nav: false,
            dots: false,
            responsive:{
                760:{
                    items:3
                },
                992:{
                    items:4
                },
                1200:{
                    items:5,
                    autoplay:false
                }
            }
        })
    };

    if ($('#products-slider').length) {
        $('#products-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: false,
            margin: 0,
            responsiveClass: false,
            items: 1,
            autoplay: true,
            autoplayTimeout: 4000,
            smartSpeed: 750,
            nav: false,
            dots: true,
            responsive: {
                760: {
                    dots: true,
                }
            }
        })
    }



    // Product Images popup
    $('.popup-image').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
        image: {
            markup: '<div class="mfp-figure">' +
                '<div class="mfp-close"></div>' +
                '<div class="mfp-img"></div>' +
                '<div class="mfp-bottom-bar">' +
                '<div class="mfp-title"></div>' +
                '</div>' +
                '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button

            cursor: 'mfp-zoom-out-cur', 
            titleSrc: 'title',
            verticalFit: true, // Fits image in area vertically
            tError: '<a href="%url%">The image</a> could not be loaded.' // Error message
        },
        disableOn: function() {
            if ($(window).width() < 600) {
                return false;
            }
            return true;
        }
    });

    //tabbed url
    if (location.hash.substr(0, 2) == "#!") {
        $("a[href='#" + location.hash.substr(2) + "']").tab("show");
    }

    $("a[data-toggle='tab']").on("shown.bs.tab", function(e) {
        var hash = $(e.target).attr("href");
        if (hash.substr(0, 1) == "#") {
            location.replace("#!" + hash.substr(1));
        }
    });


    $('#select-orderby').on('change', function() {
        var form = $(this).closest('form');
        form.submit();
    });


    // Products 
    var pricecode = $('input[name=priceid]:checked').data("pricecode");
    $('#code').val(pricecode); // populate hidden field with price code
    $('#price-code').text(pricecode);

    /* Select Price - On success updated the add to cart base code and sets form optionid */
    $('input[name=priceid]').on('click', function() {

        var pricecode = $(this).data("pricecode");
        // var price = $(this).find(':selected').data("price");

        if (pricecode) {
            $('#code').val(pricecode); // populate hidden field with price code
            $('#price-code').text(pricecode);
        }
    });

    // ADD to Cart
    // $('#form-addtocart').unbind("submit");
    $('.btn-addtocart').on('click', function(event) {
        // check radio button
        var priceid = $(this).data('priceid');
        $('#priceid-' + priceid).attr('checked', true);

        $('#form-addtocart').submit();
    });


    $('#form-addtocart').on('submit', function(event) {

        event.preventDefault();

        $(this).find('input[name=postmethod]').val('AJAX');

        // convert form values to JSON string
        formdata = JSON.stringify($(this).serializeArray());

        $url = '/app/post/';
        //location.href=url; // redirect for debugging
        event.stopPropagation();

        $.ajax({
            url: $url,
            context: $(this),
            method: 'post',
            data: JSON.parse(formdata),
            dataType: 'json',
            beforeSend: function(xhr) {
                $('#response').html('');
            }
        }).done(function(response) {

            // show confirm alert
            $('#response').html(response.message);

            // Update the cart summary
            updateCartSummary();

        });

        return false; // prevent default
    });

    // Cart
    /* Auto Update Cart when quantities change */

    $('#cart-details').on('change', '.qty-update-cart', function(event) { // use event delegation so we don't need to reload js in response

        $form = $(this).parents('form');

        $params = ($form.serialize());

        $url = '/app/post/?' + $params;

        event.stopPropagation();

        $.ajax({
            url: $url,
            method: 'post',
            context: $(this),
            beforeSend: function(xhr) {

                $('#cart-details').html('Updating cart...');

            }
        }).done(function(response) {

            $('#cart-details').html(response);

            // Update the cart summary
            updateCartSummary();

        });

        return false; // prevent default

    });



    /* REMOVE from Cart Links */
    $('#cart-details').on('click', 'a.remove-from-cart', function(event) { // use event delegation so we don't need to reload js in response

        // event.stopImmediatePropagation();

        var msg = 'Are you sure you want to remove this product from your cart?';

        // quick alert - maybe use a modal popup instead
        if (confirm(msg)) {

            $.ajax({
                url: $(this).attr('href'),
                context: $(this),
                method: 'post',
                beforeSend: function(xhr) {
                    $('#cart-details').html('Updating cart...');
                }
            }).done(function(response) {

                $('#cart-details').html(response);

                // Update the cart summary
                updateCartSummary();

            });

        }
        return false; // prevent default

    });

    /* REMOVE from Cart Summary */
    $('#cart-nav').on('click', 'a.remove-from-cart-summary', function(event) {

        event.stopPropagation();

        var msg = 'Are you sure you want to remove this product from your cart?';

        // quick alert - maybe use a modal popup instead
        if (confirm(msg)) {

            $.ajax({
                url: $(this).attr('href'),
                method: 'post',
                context: $(this),
                beforeSend: function(xhr) {
                    //$('#cart-details').html('Updating cart...'); 
                }
            }).done(function(response) {
                // Update the cart summary
                updateCartSummary();
            });

        }
        return false; // prevent default

    });

    /* Apply Voucher */
    $('#cart-details').on('click', 'button.apply-voucher', function(event) {

        $form = $(this).parents('form');

        // $params = ($form.serialize());

        // convert form values to JSON string
        formdata = JSON.stringify($form.serializeArray());

        $url = '/app/post/';

        // event.stopPropagation();

        $.ajax({
            url: $url,
            method: 'post',
            data: JSON.parse(formdata),
            context: $(this),
            beforeSend: function(xhr) {

                $('#apply-voucher').html('Applying discount...');

            }
        }).done(function(response) {

            $('#cart-details').html(response);

            // Update the cart summary
            updateCartSummary();

        });

        return false; // prevent default

    });

    // Remove voucher code
    $('#cart-details').on('click', 'a.remove-voucher', function(event) {

        event.stopPropagation();

        var msg = 'Are you sure you want to remove this voucher code from your order?';

        // quick alert - maybe use a modal popup instead
        if (confirm(msg)) {
            $.ajax({
                url: $(this).attr('href'),
                beforeSend: function(xhr) {
                    // $('#cart-details').html('Updating cart...'); 
                }
            }).done(function(response) {
                $('#cart-details').html(response);
                // Update the cart summary
                updateCartSummary();
            });
        }
        return false; // prevent default

    });

    /* Calculate Freight - When delivery region or rural delivery is changed */
    if ($('#form-checkout').length) {

        // call if on checkout page
        calculateFreight();

        $('.calculate-freight').on('change', function(event) {

            // call calc freight
            calculateFreight();

        });

    }

    $('[data-provide="datepicker"]').datepicker();
})

// Updates the cart summaries on side and in header
function updateCartSummary() {

    // update header cart summary items
    $.ajax({
        url: '/app/post/',
        context: $('#cart-nav'),
        method: 'post',
        data: {
            'saction': 'RELOADCARTSUMMARY'
        },
        beforeSend: function(xhr) {
            // preloader animation ??
        }
    }).done(function(response) {
        // Update the cart summary
        $('#cart-nav').html(response);
    });

}

// set the delivery address fields
function updateDeliveryMethod() {
    var deliverymethod = $('#delivery-method').val();
    if (deliverymethod == 'pickup') {
        $('.delivery-fields').addClass('hide');
        $('#pickup-details').removeClass('hide');
    } else {
        $('.delivery-fields').removeClass('hide');
        $('#pickup-details').addClass('hide');
    }
}

// Updates the cart freight when reion is changed or freight type is changed
function calculateFreight() {

    var regionid = $("#delivery-region").val();
    var deliverymethod = $("#delivery-method").val();
    var rural = $("#delivery-rural:checked").val();

    $url = '/app/post/';

    $.ajax({
        url: $url,
        method: 'post',
        data: {
            saction: 'CALCULATEFREIGHT',
            d_regionid: regionid,
            d_rural_delivery: rural,
            deliverymethod: deliverymethod
        },
        context: $(this)
    }).done(function(response) {
        // update checkout cart confirmation details
        $('#cart-confirmation').html(response);
    });

    // update paymenttype 
    if ($('input[name=ordertotal]').val() <= 0) {
        $('input[name=paymenttype]').val('voucher');
    } else {
        $('input[name=paymenttype]').val('creditcard');
    }

}

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    // load location map details
    if ($('#map-contact').length) {
        $.getScript("/js/gmap-min.js", function(data, textStatus, jqxhr) {});
    }
    if ($('#map-locations-list').length) {
        $.getScript("/js/locations-map-min.js", function(data, textStatus, jqxhr) {
            // console.log( data ); // Data returned
            // console.log( textStatus ); // Success
            // console.log( jqxhr.status ); // 200
            // console.log( "Load was performed." );
        });
    }

    // load location map details
    if ($('#map-location').length) {
        $.getScript("/js/gmap-min.js", function(data, textStatus, jqxhr) {});
    }

}


// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js